'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { useClientData } from '@headless-workspace/domain/common/client';
import { GlowIcon, GlowTextBody, Icons } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { ProductReview, ReviewPurchaserType } from '../../../../../server';

type ReviewPurchaserBadgeProps = {
    purchaserType: ProductReview['purchaserType'];
};

export const ReviewPurchaserBadge: Component<ReviewPurchaserBadgeProps> = ({ purchaserType }) => {
    const t = useTranslations('Discover.Pdp.ratingAndReviews');

    const { getClientFlags } = useClientData();
    const isMySephoraActivated = getClientFlags('isMySephoraActivated');

    const badgeLabel = useMemo(() => {
        switch (purchaserType) {
            case ReviewPurchaserType.RewardedBuyer:
                return isMySephoraActivated ? t('label.rewardedBuyer') : t('label.verifiedPurchaser');
            case ReviewPurchaserType.VerifiedBuyer:
                return t('label.verifiedPurchaser');
            case ReviewPurchaserType.Tester:
                return t('label.testerPurchaser');
            case ReviewPurchaserType.Spontaneous:
                return t('label.spontaneousPurchaser');
        }
    }, [purchaserType, isMySephoraActivated, t]);

    if (purchaserType === ReviewPurchaserType.RewardedBuyer || purchaserType === ReviewPurchaserType.VerifiedBuyer) {
        return (
            <div className={'flex gap-0.5 items-center'}>
                <GlowIcon Icon={Icons.Verified} type={'fullSize'} width={'1rem'} height={'1rem'} />
                <GlowTextBody text={badgeLabel} />
            </div>
        );
    }

    return <GlowTextBody text={badgeLabel} />;
};
